import { env } from '@/utils/env';
import { IS_CA } from '@/utils/constants';

/**
 * Z -CA 不同语种用户进站体验优化
 * https://alidocs.dingtalk.com/i/nodes/amweZ92PV6vw1LdxIKN0DvQjVxEKBD6p?utm_scene=team_space
 */
const SUPPORTED_BROWSER_LANGUAGES = ['it', 'pt', 'es', 'de', 'fr', 'nl', 'fi'];

type AutoMatchedLanguage = 'it' | 'pt' | 'es' | 'de' | 'fr' | 'nl' | 'fi' | 'en';

function getNavigatorLanguages() {
  if (typeof navigator === 'undefined') return [];
  return navigator.languages?.length > 0 ? navigator.languages : [navigator.language];
}

export function getBrowserLanguage(
  preferredLanguages: readonly string[] | null = getNavigatorLanguages(),
): AutoMatchedLanguage | null {
  if (env.NEXT_PUBLIC_ENABLE_GOOGLE_TRANSLATE !== 'true' || !IS_CA) {
    return null;
  }

  const [primaryLanguage] = preferredLanguages || [];
  const languageCode = primaryLanguage?.split('-')[0]?.toLowerCase();

  if (languageCode && SUPPORTED_BROWSER_LANGUAGES.includes(languageCode)) {
    return languageCode as AutoMatchedLanguage;
  }

  return 'en';
}
